import {
  differenceInDays, format, parseISO, subDays,
} from 'date-fns';
import update from 'immutability-helper';

import {
  CLEAR_VBT_DASH_LINK,
  CLEAR_VBT_DATA,
  CREATE_VBT_TEMPLATE_FULFILLED,
  CREATE_VBT_TEMPLATE_REJECTED,
  CREATE_VBT_TEMPLATE_START,
  DELETE_VBT_TEMPLATE_FULFILLED,
  DELETE_VBT_TEMPLATE_REJECTED,
  DELETE_VBT_TEMPLATE_START,
  DUPLICATE_VBT_TEMPLATE_FULFILLED,
  DUPLICATE_VBT_TEMPLATE_REJECTED,
  DUPLICATE_VBT_TEMPLATE_START,
  EDIT_VBT_TEMPLATE_FULFILLED,
  EDIT_VBT_TEMPLATE_REJECTED,
  EDIT_VBT_TEMPLATE_START,
  FETCH_ATHLETES_FULFILLED,
  FETCH_ATHLETES_REJECTED,
  FETCH_ATHLETES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  FETCH_GROUPS_START,
  FETCH_PUBLIC_VBT_DATA_FULFILLED,
  FETCH_PUBLIC_VBT_DATA_REJECTED,
  FETCH_PUBLIC_VBT_DATA_START,
  FETCH_SHARE_VBT_DASH_LINK_FULFILLED,
  FETCH_SHARE_VBT_DASH_LINK_REJECTED,
  FETCH_SHARE_VBT_DASH_LINK_START,
  FETCH_VBT_DATA_FULFILLED,
  FETCH_VBT_DATA_REJECTED,
  FETCH_VBT_DATA_START,
  FETCH_VBT_TEMPLATES_FULFILLED,
  FETCH_VBT_TEMPLATES_REJECTED,
  FETCH_VBT_TEMPLATES_START,
  SET_ABOUT_VBT_DASH_MODAL,
  SET_ACTIVE_VBT_DASH,
  SET_DATE_RANGE,
  SET_DELETE_VBT_DASH_MODAL,
  SET_DUPLICATE_VBT_DASH_MODAL,
  SET_EDIT_VBT_DASH_MODAL,
  SET_END_DATE_DATA,
  SET_EXERCISES,
  SET_GRAPH_THRESHOLDS,
  SET_GROUP,
  SET_GROUPS,
  SET_NEXT_LOCATION,
  SET_SELECTED_ATHLETE,
  SET_SELECTED_END_DATE_ANALYSIS,
  SET_SELECTED_END_DATE_OVERVIEW,
  SET_SELECTED_EXERCISE,
  SET_SHARE_VBT_DASH_MODAL,
  SET_START_DATE,
  SET_TABLE_THRESHOLD,
} from './actionTypes';

const initialState = {
  aboutTemplate: {},
  activeTemplate: null,
  athletes: [],
  availableExercises: [],
  createTemplateError: null,
  dateRange: 13,
  dashBGColor: null,
  dashCreator: null,
  dashDescription: null,
  dashLogo: null,
  dashTitle: null,
  deleteError: null,
  deleteTemplate: {},
  dupError: null,
  duplicateTemplate: {},
  editError: null,
  editTemplate: {},
  endDateData: format(new Date(), 'yyyy-MM-dd'),
  exercises: [],
  graphThresholds: [],
  group: null,
  groups: [],
  nextLocation: null,
  selectedAthlete: null,
  selectedEndDateAnalysis: new Date(),
  selectedEndDateOverview: new Date(),
  selectedExercise: null,
  shareDashLink: null,
  shareDashLinkError: null,
  shareTemplate: {},
  startDate: format(subDays(new Date(), 13), 'yyyy-MM-dd'),
  tableThreshold: {},
  templateError: null,
  templates: [],
  vbtData: null,
  vbtError: null,
  weightType: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_VBT_DATA:
      return {
        ...state,
        activeTemplate: null,
        dateRange: 13,
        endDateData: format(new Date(), 'yyyy-MM-dd'),
        exercises: [],
        graphThresholds: [],
        group: null,
        selectedAthlete: null,
        selectedEndDateAnalysis: new Date(),
        selectedEndDateOverview: new Date(),
        selectedExercise: null,
        startDate: format(subDays(new Date(), 13), 'yyyy-MM-dd'),
        tableThreshold: {},
        vbtData: null,
      };
    case CLEAR_VBT_DASH_LINK:
      return {
        ...state,
        shareDashLink: null,
        shareDashLinkError: null,
      };
    case CREATE_VBT_TEMPLATE_START:
      return {
        ...state,
        createTemplateError: null,
      };
    case CREATE_VBT_TEMPLATE_FULFILLED:
      return {
        ...state,
        activeTemplate: action.payload,
        createTemplateError: null,
        templates: [...state.templates, action.payload],
      };
    case CREATE_VBT_TEMPLATE_REJECTED:
      return {
        ...state,
        createTemplateError: action.payload,
      };
    case DELETE_VBT_TEMPLATE_START:
      return {
        ...state,
        deleteError: null,
      };
    case DELETE_VBT_TEMPLATE_FULFILLED:
      return update(state, {
        deleteError: {
          $set: null,
        },
        deleteTemplate: {
          $set: {},
        },
        templates: {
          $splice: [[action.payload.index, 1]],
        },
      });
    case DELETE_VBT_TEMPLATE_REJECTED:
      return {
        ...state,
        deleteError: action.payload,
      };
    case DUPLICATE_VBT_TEMPLATE_START:
      return {
        ...state,
        dupError: null,
      };
    case DUPLICATE_VBT_TEMPLATE_FULFILLED:
      return update(state, {
        dupError: {
          $set: null,
        },
        templates: {
          $push: [action.payload],
        },
      });
    case DUPLICATE_VBT_TEMPLATE_REJECTED:
      return {
        ...state,
        dupError: action.payload,
      };
    case EDIT_VBT_TEMPLATE_START:
      return {
        ...state,
        editError: null,
      };
    case EDIT_VBT_TEMPLATE_FULFILLED:
      return update(state, {
        editError: {
          $set: null,
        },
        editTemplate: {
          $set: {},
        },
        templates: {
          [action.payload.index]: {
            $set: action.payload.data,
          },
        },
      });
    case EDIT_VBT_TEMPLATE_REJECTED:
      return {
        ...state,
        editError: action.payload,
      };
    case FETCH_ATHLETES_START:
      return {
        ...state,
        athletes: [],
      };
    case FETCH_ATHLETES_FULFILLED:
      return {
        ...state,
        athletes: action.payload,
      };
    case FETCH_ATHLETES_REJECTED:
      return {
        ...state,
        athletes: [],
      };
    case FETCH_EXERCISES_START:
      return {
        ...state,
        availableExercises: [],
      };
    case FETCH_EXERCISES_FULFILLED:
      return {
        ...state,
        availableExercises: action.payload,
      };
    case FETCH_EXERCISES_REJECTED:
      return {
        ...state,
        availableExercises:
              action.payload.response && action.payload.response.data
                ? action.payload.response.data
                : action.payload,
      };
    case FETCH_GROUPS_START:
      return {
        ...state,
        groups: [],
      };
    case FETCH_GROUPS_FULFILLED:
      return {
        ...state,
        groups: action.payload,
      };
    case FETCH_GROUPS_REJECTED:
      return {
        ...state,
        groups: [],
      };
    case FETCH_PUBLIC_VBT_DATA_START:
      return {
        ...state,
        vbtError: null,
      };
    case FETCH_PUBLIC_VBT_DATA_FULFILLED:
      return {
        ...state,
        athletes: action.payload.users.sort((a, b) => a.name.localeCompare(b.name)),
        dateRange: differenceInDays(
          parseISO(action.payload.endDate), parseISO(action.payload.startDate),
        ),
        dashBGColor: action.payload.account.primaryColor,
        dashCreator: action.payload.creator,
        dashDescription: action.payload.dashboardDescription,
        dashLogo: action.payload.account.logo,
        dashTitle: action.payload.dashboardTitle,
        endDateData: parseISO(action.payload.endDate),
        exercises: action.payload.exercises.sort((a, b) => a.name.localeCompare(b.name)),
        graphThresholds: action.payload.thresholds.graphThresholds,
        group: action.payload.group,
        selectedEndDateAnalysis: parseISO(action.payload.endDate),
        selectedEndDateOverview: parseISO(action.payload.endDate),
        selectedExercise: action.payload.exercise || null,
        startDate: parseISO(action.payload.startDate),
        tableThreshold: action.payload.thresholds.tableThreshold,
        vbtData: action.payload.dashboardData || true,
        vbtError: null,
        weightType: action.payload.account.weightType,
      };
    case FETCH_PUBLIC_VBT_DATA_REJECTED:
      return {
        ...state,
        vbtData: null,
        vbtError: action.payload,
      };
    case FETCH_SHARE_VBT_DASH_LINK_START:
      return {
        ...state,
        shareDashLink: null,
        shareDashLinkError: null,
      };
    case FETCH_SHARE_VBT_DASH_LINK_FULFILLED:
      return {
        ...state,
        shareDashLink: action.payload,
        shareDashLinkError: null,
      };
    case FETCH_SHARE_VBT_DASH_LINK_REJECTED:
      return {
        ...state,
        shareDashLink: null,
        shareDashLinkError: action.payload,
      };
    case FETCH_VBT_DATA_START:
      return {
        ...state,
        vbtError: null,
      };
    case FETCH_VBT_DATA_FULFILLED:
      return {
        ...state,
        vbtData: action.payload,
        vbtError: null,
      };
    case FETCH_VBT_DATA_REJECTED:
      return {
        ...state,
        vbtData: null,
        vbtError: action.payload,
      };
    case FETCH_VBT_TEMPLATES_START:
      return {
        ...state,
        templateError: null,
      };
    case FETCH_VBT_TEMPLATES_FULFILLED:
      return {
        ...state,
        templates: action.payload,
        templateError: null,
      };
    case FETCH_VBT_TEMPLATES_REJECTED:
      return {
        ...state,
        templates: [],
        templateError: action.payload,
      };
    case SET_ABOUT_VBT_DASH_MODAL:
      return {
        ...state,
        aboutTemplate: action.payload.template,
      };
    case SET_ACTIVE_VBT_DASH:
      return {
        ...state,
        activeTemplate: action.payload,
      };
    case SET_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };
    case SET_DELETE_VBT_DASH_MODAL:
      return {
        ...state,
        deleteTemplate: action.payload.template,
      };
    case SET_DUPLICATE_VBT_DASH_MODAL:
      return {
        ...state,
        duplicateTemplate: action.payload.template,
      };
    case SET_EDIT_VBT_DASH_MODAL:
      return {
        ...state,
        editTemplate: action.payload.template,
      };
    case SET_END_DATE_DATA:
      return {
        ...state,
        endDateData: action.payload,
      };
    case SET_EXERCISES:
      return {
        ...state,
        exercises: action.payload,
      };
    case SET_GRAPH_THRESHOLDS:
      return {
        ...state,
        graphThresholds: action.payload,
      };
    case SET_GROUP:
      return {
        ...state,
        group: action.payload,
      };
    case SET_GROUPS:
      return {
        ...state,
        groups: action.payload,
      };
    case SET_NEXT_LOCATION:
      return {
        ...state,
        nextLocation: action.payload,
      };
    case SET_SELECTED_ATHLETE:
      return {
        ...state,
        selectedAthlete: action.payload.athlete,
      };
    case SET_SELECTED_END_DATE_ANALYSIS:
      return {
        ...state,
        selectedEndDateAnalysis: action.payload,
      };
    case SET_SELECTED_END_DATE_OVERVIEW:
      return {
        ...state,
        selectedEndDateOverview: action.payload,
      };
    case SET_SELECTED_EXERCISE:
      return {
        ...state,
        selectedExercise: action.payload.exer,
      };
    case SET_SHARE_VBT_DASH_MODAL:
      return {
        ...state,
        shareTemplate: action.payload.template,
      };
    case SET_START_DATE:
      return {
        ...state,
        startDate: action.payload,
      };
    case SET_TABLE_THRESHOLD:
      return {
        ...state,
        tableThreshold: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
